import React, { useState, useEffect, useRef } from "react";
import { useWatch } from "react-hook-form";
import { currencyStringToNumber } from "../../../utilities/numericFormat.js";

//** ndbx */
import {
	CurrencyInputCard,
	Section,
	RHFRadioGroup,
	// RHFCircleToggleGroupLabelled,
} from "@arp/react-ndbx";

import { RHFCircleToggleGroupLabelled } from "../../../components/coding/rhfToggleButtonGroupLabelled";

//** MUI Components */
import { Switch, Typography } from "@mui/material";
import useTheme from "@mui/material/styles/useTheme";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

//** Components */
import AccordionTables from "./AccordionTables.jsx";

//** Context */
import usePreQualification from "../../../hooks/usePreQualification.ts";
import useSharedData from "../../../hooks/useSharedData.ts";
import { useGetReferenceData } from "../../../hooks/dataHooks/useGetReferenceData.js";
import { useOutletContext } from "react-router-dom";

//* Hooks
import { useGetQuote } from "../../../hooks/dataHooks/useGetQuoteData.js";
import { useUpdateCoverMutation } from "../../../hooks/dataHooks/useUpdateCoverMutation.js";
import { useGetPremiumProjectionData } from "../../../hooks/dataHooks/useGetPremiumProjectionData.js";

//** Config */
import { quoteSummaryFieldNames } from "../../../config/pageInfo/pageFieldName.js";
import {
	questionTypes,
	questionLabels,
} from "../../../config/questions/questionItems.js";
import { selectCoverTooltips } from "../../../config/tooltips/pageTooltips.js";

//** Schema */
import {
	LIFE_INSURANCE_MIN,
	LIFE_INSURANCE_MAX,
	CRITICAL_ILLNESS_MIN,
	CRITICAL_ILLNESS_MAX,
	PERMANENT_DISABILITY_MIN,
	PERMANENT_DISABILITY_MAX,
} from "../../../schema/sharedConstValues.js";

//** Utilities */
import {
	formatCurrencyNoDecimal,
	formatCurrency,
	valueWithinRange,
} from "../../../utilities/numericFormat.js";
import { toUpperFirstCharacterFirstWord } from "../../../utilities/mappingHelper.js";

//----------------------------------------------------------------
export default function QuoteSummaryDetails({ ...props }) {
	const theme = useTheme();
	const firstUpdate = useRef(true);

	const COVER_REQUIRING_UPDATE = {
		LIFE: "life",
		CI: "ci",
		CI_REMOVE: "ci_remove",
		PUW: "puw",
		PUW_REMOVE: "puw_remove",
		NONE: "none",
	};

	const [coverRequiringUpdate, setCoverRequiringUpdate] = useState(
		COVER_REQUIRING_UPDATE.NONE
	);

	const {
		person,
		frequency,
		applicantTitle,
		dataSet,
		isOnline = true,
	} = {
		...props,
	};

	const { data: quoteData, isLoading: quoteIsLoading } = useGetQuote();

	const quoteInfo =
		person === "personOne"
			? quoteData.personOneQuoteInfo
			: quoteData.personTwoQuoteInfo;

	//* Shared data
	const { handleEventChange, accessToken } = useSharedData();

	//* Get reference data
	const { data: refData, isLoading: isRefDataLoading } = useGetReferenceData();
	const { occupationTypeList } = isRefDataLoading === false ? refData : {};

	const { setValues, funcSet } = usePreQualification();

	//* Update cover mutation
	// const {
	// 	mutate: updateCoverMutate,
	// 	isSuccess: isUpdateCoverSuccess,
	// 	isLoading: isUpdateCoverLoading,
	// 	error: mutError,
	// } = useUpdateCoverMutation();

	const updateCoverMutationContext = useUpdateCoverMutation();

	const {
		mutate: updateCoverMutate,
		isSuccess: isUpdateCoverSuccess,
		isLoading: isUpdateCoverLoading,
		error: mutError,
	} = { ...updateCoverMutationContext };

	const [open, setOpen] = useState(false);
	useEffect(() => {
		setOpen(isUpdateCoverLoading);
	}, [isUpdateCoverLoading]);

	const {
		methods: [methods],
		showSecond: [showSecond],
		validateTrauma: [validateTrauma],
		validateOccupation: [validateOccupation],
		errors: [errors],
		// isDirty: [isDirty],
		// isValid: [isValid],
	} = useOutletContext();
	const {
		control,
		setValue,
		clearErrors,
		resetField,
		trigger,
		// reset,
		// errorFields,
	} = {
		...methods,
	};

	let criticalIllnessWatch = "";
	let permanentDisabilityWatch = "";

	//* Get Premium Projections
	const { data: premiumProjectionData, refetch } =
		useGetPremiumProjectionData(accessToken);

	//----------------------------------------------------------------
	function anyErrors() {
		const foundErrors = Object?.keys(errors).length > 0 ? true : false;
		return foundErrors;
	}
	//!----------------------------------------------------------------

	//!----------------------------------------------------------------
	//** TODO:  1. Life Cover Functionality - Start */
	const [lifeCoverValid, setLifeCoverValid] = useState(true); //* A flag to determine if the value is valid
	const [isLifeCoverUpdated, setIsLifeCoverUpdated] = useState(true); //* Have we changed the value? We need to to trigger a call to updateCover
	// const [coverUpdated, setCoverUpdated] = useState(false); //* This is set when we leave the field.

	//* Watch for changes in the Life Cover amount
	const lifeCoverWatch = useWatch({
		control,
		name: quoteSummaryFieldNames(person).LIFE_COVER,
	});

	//* check to see if the Life Cover has been changed
	useEffect(() => {
		if (
			firstUpdate.current ||
			lifeCoverWatch == null ||
			dataSet[person]?.lifeCover?.toString() === lifeCoverWatch?.toString()
		) {
			return;
		}

		setLifeCoverValid(
			valueWithinRange(
				lifeCoverWatch,
				LIFE_INSURANCE_MIN[dataSet[person].minAgeGroup],
				LIFE_INSURANCE_MAX[dataSet[person].maxAgeGroup]
			)
		);
		setIsLifeCoverUpdated(false);
		//* Set the Shared Context API
		handleEventChange({
			name: "isCoverStateValid",
			value: false,
		});
	}, [lifeCoverWatch]);

	//** Life Cover Functionality - End */
	//!----------------------------------------------------------------

	//!----------------------------------------------------------------
	//** TODO: 2. Critical Illness Functionality - Start */
	//* Has the Critical Illness value changed
	const [showAllTraumaCover, setShowAllTraumaCover] = useState(false); //* Show the yes/no component.

	const [isCriticalIllnessCoverUpdated, setIsCriticalIllnessCoverUpdated] =
		useState(true); //* Is the component updated and valid.
	const [showTrauma, setShowTrauma] = useState(
		quoteInfo?.covers?.hasCriticalIllnessCover
	); //? WHAT IS THIS USED FOR??

	// const [callUpdateOnCriticalIllness, setCallUpdateOnCriticalIllness] =
	// 	useState(false); //* This is the SoT for when we call an update for Critical Illness cover.
	//* What should cause this to be 'true'
	//* 1. No is selected on the trauma question.
	//* 2. The checkbox is unchecked when there was a value set in CI currency component
	//* 3. The CI currency component was manually cleared and the user tabs off.

	//* Watch for changes in the Critical Illness Cover amount
	criticalIllnessWatch = useWatch({
		control,
		name: quoteSummaryFieldNames(person).CRITICAL_ILLNESS_COVER,
	});

	useEffect(() => {
		if (isUpdateCoverLoading === true) return;
		if (
			firstUpdate?.current ||
			criticalIllnessWatch == null ||
			dataSet[person]?.illnessCover?.toString() ===
				criticalIllnessWatch?.toString()
		) {
			if (
				criticalIllnessWatch != null &&
				dataSet[person]?.illnessCover?.toString() ===
					criticalIllnessWatch?.toString()
			) {
				setIsCriticalIllnessCoverUpdated(true);
			}
			return;
		}
		if (
			valueWithinRange(
				criticalIllnessWatch,
				CRITICAL_ILLNESS_MIN[dataSet[person].minAgeGroup],
				CRITICAL_ILLNESS_MAX[dataSet[person].maxAgeGroup]
			)
		) {
			setShowTrauma(true);
			setShowAllTraumaCover(true);
			validateTrauma(true, person); //* Tell the yup validation that we need to validate the Trauma Question.
			setValue(quoteSummaryFieldNames(person).TRAUMA_COVER, "");
		} else {
			// when you don't show the trauma cover set its value and error to empty
			validateTrauma(false, person);
			setValue(quoteSummaryFieldNames(person).TRAUMA_COVER, "");
			clearErrors(quoteSummaryFieldNames(person).TRAUMA_COVER);
			setShowTrauma(false);
			setShowAllTraumaCover(false);
		}

		setIsCriticalIllnessCoverUpdated(false);

		// setTraumaSelectValid(false);
		//* Set the Shared Context API
		handleEventChange({
			name: "isCoverStateValid",
			value: false,
		});
	}, [criticalIllnessWatch]);

	//* We only want to hide the Trauma question when it's been updated
	useEffect(() => {
		setShowAllTraumaCover(showTrauma);
	}, [showTrauma]);
	//** */

	//* Watch and Listen for the Trauma Cover selected
	//? Remember to add this to the state
	// const [traumaSelectValid, setTraumaSelectValid] = useState(false);
	const traumaSelect = useWatch({
		control,
		name: quoteSummaryFieldNames(person).TRAUMA_COVER,
	});

	const [doINeedToUpdateCI, setDoINeedToUpdateCI] = useState(false);
	useEffect(() => {
		if (isUpdateCoverLoading === true) return;
		const updateStateValue = async () => {
			let updateObject = {
				amount: criticalIllnessWatch,
				type: "update_question",
				person: person,
			};

			funcSet.updateCriticalIllness(updateObject);

			//* If the current traumaCover is the same as the set traumaSelect
			//* we don't want to call an update
			if (dataSet[person]?.traumaCover === traumaSelect) return;
			setDoINeedToUpdateCI(true);
		};

		updateStateValue();
	}, [traumaSelect]);

	useEffect(() => {
		if (doINeedToUpdateCI === true && showTrauma === true) {
			const outputTraumaQuestion = traumaSelect === "no";
			// setTraumaSelectValid(outputTraumaQuestion);
			if (outputTraumaQuestion === true) {
				setCoverRequiringUpdate(COVER_REQUIRING_UPDATE.CI);
				setDoINeedToUpdateCI(false);
			}
		}
	}, [dataSet, dataSet?.dataUpdating, doINeedToUpdateCI]);

	//! *** HANDLE CRITICAL ILLNESS CHECKBOX CHECK -  START */
	const handleCriticalIllnessCheckedChange = async (e) => {
		// We need to
		// 1. Clear any errors under the trauma question
		// 2. Rest the trauma question
		// 3. Hide the trauma question
		// 4. Clear the monthly/yearly premium amounts
		// 5. Clear the CI amount field
		// 6. Update local state
		// 6a  _illnessCoverPremium"
		// 6b _traumaCover
		// 7. Set a flag to say that we are REMOVING CI
		// 8. Call updateCover
		resetCriticalIllnessState(e);
	};

	const resetCriticalIllnessState = (e) => {
		e.preventDefault();
		if (!e) return;
		const { name } = e?.target;
		const split = name.split("_");

		resetField(name);
		setShowAllTraumaCover(false);
		validateTrauma(false, person);
		setValue(quoteSummaryFieldNames(person).TRAUMA_COVER, "");
		clearErrors(quoteSummaryFieldNames(person).TRAUMA_COVER);

		const isChecked = e?.target.checked;

		setCriticalIllnessChecked(isChecked); //* Is the checkbox being checked or unchecked?

		const updateField = split[0] + "_illnessCoverPremium";
		const updateQuestion = split[0] + "_traumaCover";

		let updateObject = {
			[updateField]: "",
			[updateQuestion]: "",
			type: "remove",
			person: split[0],
		};

		funcSet.updateCriticalIllness(updateObject);
		setCoverRequiringUpdate(
			e?.target.checked === true
				? COVER_REQUIRING_UPDATE.NONE
				: COVER_REQUIRING_UPDATE.CI
		);
	};
	//! *** HANDLE CRITICAL ILLNESS CHECKBOX CHECK -  END */

	//** Critical Illness Functionality - End */
	//!----------------------------------------------------------------

	//!----------------------------------------------------------------
	//** 3. TODO: Permanently unable to work - Start */
	//* Has the PUW value changed?
	const [showOccupationTypeCover, setShowOccupationTypeCover] = useState(false);
	const [isPermanentDisabilityUpdated, setIsPermanentDisabilityUpdated] =
		useState(true);
	const [showOccupationType, setShowOccupationType] = useState(
		quoteInfo?.covers?.hasUnableToWorkCover
	);

	permanentDisabilityWatch = useWatch({
		control,
		name: quoteSummaryFieldNames(person).PERMANENT_DISABILITY_COVER,
	});

	useEffect(() => {
		if (isUpdateCoverLoading === true) return;

		if (
			firstUpdate.current ||
			permanentDisabilityWatch == null ||
			dataSet[person]?.permanentDisabilityCover?.toString() ===
				permanentDisabilityWatch?.toString()
		) {
			return;
		}

		if (
			valueWithinRange(
				permanentDisabilityWatch,
				PERMANENT_DISABILITY_MIN[dataSet[person].minAgeGroup],
				PERMANENT_DISABILITY_MAX[dataSet[person].maxAgeGroup]
			)
		) {
			setShowOccupationType(true);
			setShowOccupationTypeCover(true);
			validateOccupation(true, person);
		} else {
			setValue(quoteSummaryFieldNames(person).OCCUPATION_LIST, "");
			clearErrors(quoteSummaryFieldNames(person).OCCUPATION_LIST);
			validateOccupation(false, person);
			setShowOccupationType(false);
		}
		setIsPermanentDisabilityUpdated(false);
		handleEventChange({
			name: "isCoverStateValid",
			value: false,
		});
	}, [permanentDisabilityWatch]);

	useEffect(() => {
		setShowOccupationTypeCover(showOccupationType);
	}, [showOccupationType]);

	//* Watch and Listen that the Occupation Type is selected.
	// const [occupationSelectValid, setOccupationSelectValid] = useState(false);
	const occupationSelect = useWatch({
		control,
		name: quoteSummaryFieldNames(person).OCCUPATION_LIST,
	});

	const [doINeedToUpdatePUW, setDoINeedToUpdatePUW] = useState(false);
	useEffect(() => {
		const updateStateValue = async () => {
			if (isUpdateCoverLoading === true) return;

			if (occupationSelect === "11-U") return; //? We don't need to update the list for unemployed

			let updateObject = {
				amount: permanentDisabilityWatch,
				updateField: occupationSelect,
				type: "update_question",
				person: person,
			};

			funcSet.updatePermanentDisabilityCover(updateObject);

			//* If the current occupationList is the same as the set occupationList (occupationSelect)
			//* we don't want to call an update
			if (dataSet[person]?.occupationList === occupationSelect) return;

			setDoINeedToUpdatePUW(true);
		};
		updateStateValue();
	}, [occupationSelect]);

	useEffect(
		() => {
			if (isUpdateCoverLoading === true) return;
			if (occupationSelect === "" || occupationSelect === "11-U") return;
			if (doINeedToUpdatePUW === true && showOccupationType === true) {
				setCoverRequiringUpdate(COVER_REQUIRING_UPDATE.PUW);
				setDoINeedToUpdatePUW(false);
			}
		},
		[(dataSet, dataSet?.dataUpdating)],
		isUpdateCoverLoading
	);

	//! *** HANDLE Permanently Unable to Work CHECKBOX CHECK -  START */
	const handleUnableToWorkCheckedChange = async (e) => {
		// We need to
		// 1. Clear any errors under the occupation list
		// 2. Rest the occupation list
		// 3. Hide the occupation list
		// 4. Clear the monthly/yearly premium amounts
		// 5. Clear the PUW amount field
		// 6. Update local state
		// 6a  _permanentDisabilityCoverPremium"
		// 6b _traumaCover
		// 7. Set a flag to say that we are REMOVING CI
		// 8. Call updateCover
		resetUnableToWorkState(e);
	};

	const resetUnableToWorkState = (e) => {
		e.preventDefault();
		if (!e) return;
		const { name } = e?.target;
		const split = name.split("_");

		resetField(name);
		setShowOccupationTypeCover(false);
		validateOccupation(false, person);
		setPermanentDisabilityCoverAmount("");

		setValue(quoteSummaryFieldNames(person).OCCUPATION_LIST, "");
		clearErrors(quoteSummaryFieldNames(person).OCCUPATION_LIST);

		const isChecked = e?.target.checked;
		setPermanentUnableToWorkChecked(isChecked); //* Is the checkbox being checked or unchecked?

		const updateField = split[0] + "_permanentDisabilityCoverPremium";

		let updateObject = {
			[updateField]: "",
			type: "remove",
			person: split[0],
		};

		funcSet.updatePermanentDisabilityCover(updateObject);
		setCoverRequiringUpdate(
			e?.target.checked === true
				? COVER_REQUIRING_UPDATE.NONE
				: COVER_REQUIRING_UPDATE.PUW
		);
	};
	//! *** HANDLE Permanently Unable to Work CHECKBOX CHECK -  START */
	//** Permanently unable to work - End */

	//!----------------------------------------------------------------

	//!----------------------------------------------------------------
	//? DO WE NEED THESE?
	const [criticalIllnessCoverAmount, setCriticalIllnessCoverAmount] = useState(
		dataSet[person].illnessCover
	);

	const [permanentDisabilityCoverAmount, setPermanentDisabilityCoverAmount] =
		useState(dataSet[person].permanentDisabilityCover);
	//? DO WE NEED THESE?

	//----------------------------------------------------------------

	//** Checkbox check  */
	const [criticalIllnessChecked, setCriticalIllnessChecked] = useState(
		quoteInfo?.covers?.hasCriticalIllnessCover || false
	);

	useEffect(() => {
		setCriticalIllnessChecked(quoteInfo?.covers?.hasCriticalIllnessCover);
	}, [quoteInfo?.covers?.hasCriticalIllnessCover]);

	const [permanentUnableToWorkChecked, setPermanentUnableToWorkChecked] =
		useState(quoteInfo?.covers?.hasUnableToWorkCover || false);

	useEffect(() => {
		setPermanentUnableToWorkChecked(quoteInfo?.covers?.hasUnableToWorkCover);
	}, [quoteInfo?.covers?.hasUnableToWorkCover]);
	//** Checkbox check  */

	//** Handle the currency checkbox - End **/

	//----------------------------------------------------------------
	//** Handle the currency onBlur event - Start **/
	function isObjEmpty(obj) {
		return Object?.keys(obj)?.length === 0;
	}

	const checkValueOfLifeCover = async (coverValue) => {
		let isLifeCoverValid = true;
		let criticalIllnessLessThanLifeCover = true;
		let unableToWorkLessThanLifeCover = true;

		if (coverValue === "") return isLifeCoverValid;

		if (criticalIllnessWatch != null && criticalIllnessWatch !== "") {
			criticalIllnessLessThanLifeCover =
				Number(coverValue) < Number(criticalIllnessWatch) ? false : true;

			await setErrorOnCriticalIllness(criticalIllnessLessThanLifeCover);
		}

		if (permanentDisabilityWatch != null && permanentDisabilityWatch !== "") {
			unableToWorkLessThanLifeCover =
				Number(coverValue) < Number(permanentDisabilityWatch) ? false : true;

			await setErrorOnUnableToWork(unableToWorkLessThanLifeCover);
		}
		isLifeCoverValid =
			criticalIllnessLessThanLifeCover && unableToWorkLessThanLifeCover;
		return isLifeCoverValid;
	};

	const setErrorOnCriticalIllness = async (criticalIllnessLessThan) => {
		if (criticalIllnessLessThan === false) {
			setIsCriticalIllnessCoverUpdated(false);
			trigger(quoteSummaryFieldNames(person).CRITICAL_ILLNESS_COVER);
			// setValue(quoteSummaryFieldNames(person).TRAUMA_COVER, "");
			clearErrors(quoteSummaryFieldNames(person).TRAUMA_COVER);
			setShowAllTraumaCover(false);
			validateTrauma(false, person);
		} else {
			clearErrors(quoteSummaryFieldNames(person).CRITICAL_ILLNESS_COVER);
			setShowAllTraumaCover(true);
			validateTrauma(true, person);
		}
	};

	const setErrorOnUnableToWork = async (unableToWorkLessThan) => {
		if (unableToWorkLessThan === false) {
			setIsPermanentDisabilityUpdated(false);
			trigger(quoteSummaryFieldNames(person).PERMANENT_DISABILITY_COVER);
			// setValue(quoteSummaryFieldNames(person).OCCUPATION_LIST, "");
			clearErrors(quoteSummaryFieldNames(person).OCCUPATION_LIST);
			setShowOccupationTypeCover(false);
			validateOccupation(false, person);
		} else {
			clearErrors(quoteSummaryFieldNames(person).PERMANENT_DISABILITY_COVER);
			setShowOccupationTypeCover(true);
			validateOccupation(true, person);
		}
	};

	//! ON BLUR - START
	const handleOnBlur = async (e) => {
		e.preventDefault();
		// setCoverUpdated(false);

		// if (anyErrors() === true) return;
		//* First thing we need to do is check to ensure that the
		//* Life Cover is not less than the Optional Covers.

		//** When we onnBlur (Leave a field) for any of the covers,  */
		//** We need to call update cover  */
		//** Note: Ensure that that field is valid before trying to make the call. */
		if (!e) return;
		const { name, value } = e?.target;
		const split = name.split("_");
		const valueAmt = value;

		switch (split[1]) {
			case "lifeCover": {
				const valueAsInteger =
					value === "" ? "" : parseFloat(currencyStringToNumber(value), 0);

				let updateObject = { [e?.target.name]: valueAsInteger };
				await setValues(updateObject);

				const isFormValid = await checkValueOfLifeCover(valueAsInteger);

				if (isFormValid === false) break;

				// setCoverUpdated(true); //! TODO: I THINK THAT THIS CAN BE REMOVED.
				setCoverRequiringUpdate(COVER_REQUIRING_UPDATE.LIFE);
				break;
			}
			case "illnessCover": {
				//trigger(quoteSummaryFieldNames(person).TRAUMA_COVER);
				if (valueAmt === "" || valueAmt == null) {
					// Clean up the events
					resetCriticalIllnessState(e);
					break;
				} else {
					const valueAsInteger =
						value === "" ? "" : parseFloat(currencyStringToNumber(value), 10);

					let updateObject = {
						amount: valueAsInteger,
						type: "add",
						person: person,
					};

					funcSet.updateCriticalIllness(updateObject);

					setCoverRequiringUpdate(COVER_REQUIRING_UPDATE.NONE);
				}
				trigger(quoteSummaryFieldNames(person).TRAUMA_COVER);
				break;
			}
			case "permanentDisabilityCover": {
				trigger(quoteSummaryFieldNames(person).OCCUPATION_LIST);
				if (valueAmt === "" || valueAmt == null) {
					// Clean up the events
					resetUnableToWorkState(e);
					break;
				} else {
					const valueAsInteger =
						value === "" ? "" : parseFloat(currencyStringToNumber(value), 10);

					let updateObject = {
						amount: valueAsInteger,
						type: "add",
						person: person,
					};

					funcSet.updatePermanentDisabilityCover(updateObject);
					setCoverRequiringUpdate(COVER_REQUIRING_UPDATE.NONE);
					break;
				}
			}
			default: {
				break;
			}
		}
	};
	//! ON BLUR - END

	const [currentPerson, setCurrentPerson] = useState({});
	//* On Page Load
	useEffect(() => {
		// Check if there is a value in Critical Illness
		// and check Permanently Unable to Work
		cleanUpCoverEvents(dataSet[person]);
		if (dataSet[person]) {
			setCurrentPerson(dataSet[person]);
		}

		//* make sure that all the update flags are
		//* reset on load
		firstUpdate.current = false;
		setIsLifeCoverUpdated(true);
		setIsCriticalIllnessCoverUpdated(true);
		// setTraumaSelectValid(false);
		setIsPermanentDisabilityUpdated(true);
		// setOccupationSelectValid(false);

		//* Let the layout page know we are doing updates.
		handleEventChange({
			name: "updatingQuoteSummary",
			value: true,
		});

		setCoverRequiringUpdate(COVER_REQUIRING_UPDATE.NONE);
	}, []);

	const cleanUpCoverEvents = (personDetails) => {
		if (personDetails.illnessCover === "") {
			cleanUpIllnessCover();
		}
		if (personDetails.permanentDisabilityCover === "") {
			cleanUpPermanentDisabilityCover();
		}
	};

	//* Reset everything associated with Critical Illness Cover
	const cleanUpPermanentDisabilityCover = () => {
		permanentDisabilityWatch = "";
		resetField(quoteSummaryFieldNames(person).PERMANENT_DISABILITY_COVER);
		setShowOccupationTypeCover(false);
		validateOccupation(false, person);
		setValue(quoteSummaryFieldNames(person).OCCUPATION_LIST, "");
		clearErrors(quoteSummaryFieldNames(person).OCCUPATION_LIST);
	};

	//* Reset everything associated with Permanent Disability Cover
	const cleanUpIllnessCover = () => {
		criticalIllnessWatch = "";
		resetField(quoteSummaryFieldNames(person).CRITICAL_ILLNESS_COVER);
		setShowAllTraumaCover(false);
		validateTrauma(false, person);
		setValue(quoteSummaryFieldNames(person).TRAUMA_COVER, "");
		clearErrors(quoteSummaryFieldNames(person).TRAUMA_COVER);
	};

	//! HERE ----------------------------------------------------------------
	useEffect(() => {
		const updateCoverAmounts = async () => {
			//* Check that everything on the page is valid before trying to update
			if (dataSet == null || dataSet?.dataUpdating === true) return;

			trigger().then(async (isValid) => {
				if (!isValid) return;
				else {
					switch (coverRequiringUpdate) {
						case COVER_REQUIRING_UPDATE.NONE:
							break;
						case COVER_REQUIRING_UPDATE.LIFE:
						case COVER_REQUIRING_UPDATE.CI:
						case COVER_REQUIRING_UPDATE.PUW:
							if (anyErrors() === false) {
								updateCoverMutate({
									updateData: dataSet,
									accessToken: accessToken,
									enabled: false,
								});
							}
							break;
						default:
							break;
					}
				}
			});
		};

		updateCoverAmounts();
	}, [dataSet, dataSet?.dataUpdating, coverRequiringUpdate]);

	//* Check that the update has been successful.
	//* We should only reset the the update states for each cover
	//* if they were valid and allowed to be updated.
	//* for example, if we update critical illness but don't
	//* click 'No' on the question, then don't update.
	useEffect(() => {
		setIsLifeCoverUpdated(
			quoteInfo?.covers?.hasLifeCover === true ? true : isUpdateCoverSuccess
		);
		setIsCriticalIllnessCoverUpdated(
			quoteInfo?.covers?.hasCriticalIllnessCover === true
				? true
				: isUpdateCoverSuccess
		);
		setIsPermanentDisabilityUpdated(
			quoteInfo?.covers?.hasUnableToWorkCover === true
				? true
				: isUpdateCoverSuccess
		);

		//* This is the SoT for when Critical Illness should be updated.
		//! REMOVED.
		// setCallUpdateOnCriticalIllness(false);

		//* After a successful update, rest the flag to tell
		//* our component that nothing needs to be updated.
		setCoverRequiringUpdate(COVER_REQUIRING_UPDATE.NONE);

		handleEventChange({
			name: "isCoverStateValid",
			value: true,
		});
	}, [isUpdateCoverSuccess, quoteInfo]);

	const frequencyDisplay = { monthly: "monthly", annual: "yearly" };
	useEffect(() => {
		//** Set the form values if we are coming from the policy retrieval */
		if (quoteIsLoading || dataSet?.customerRetrieveQuoteLoaded === false)
			return;

		setValue(
			quoteSummaryFieldNames(person).LIFE_COVER,
			dataSet[person].lifeCover,
			{ shouldDirty: true }
		);

		const hasCriticalIllnessCover =
			!isNaN(dataSet[person]?.illnessCover) &&
			dataSet[person]?.illnessCover?.toString().length > 0;

		setShowAllTraumaCover(hasCriticalIllnessCover);

		if (hasCriticalIllnessCover === true) {
			setValue(
				quoteSummaryFieldNames(person).CRITICAL_ILLNESS_COVER,
				dataSet[person].illnessCover,
				{ shouldDirty: true }
			);

			setValue(
				quoteSummaryFieldNames(person).TRAUMA_COVER,
				dataSet[person].traumaCover,
				{ shouldDirty: true }
			);
		}

		const hasPermanentDisabilityCover =
			!isNaN(dataSet[person]?.permanentDisabilityCover) &&
			dataSet[person]?.permanentDisabilityCover?.toString().length > 0;

		setShowOccupationTypeCover(hasPermanentDisabilityCover);

		if (hasPermanentDisabilityCover === true) {
			setValue(
				quoteSummaryFieldNames(person).PERMANENT_DISABILITY_COVER,
				dataSet[person].permanentDisabilityCover,
				{ shouldDirty: true }
			);
			setValue(
				quoteSummaryFieldNames(person).OCCUPATION_LIST,
				dataSet[person].occupationList,
				{ shouldDirty: true }
			);
		}
	}, [dataSet?.customerRetrieveQuoteLoaded]);

	// useEffect(() => {
	//   //** Set the form values if we are coming from the policy retrieval */
	//   if (quoteIsLoading || dataSet?.customerRetrieveQuoteLoaded === false)
	//     return;

	//   setValue(
	//     quoteSummaryFieldNames(person).LIFE_COVER,
	//     dataSet[person].lifeCover,
	//     { shouldDirty: true }
	//   );

	//   setValue(
	//     quoteSummaryFieldNames(person).CRITICAL_ILLNESS_COVER,
	//     dataSet[person].criticalIllness,
	//     { shouldDirty: true }
	//   );

	//   setValue(
	//     quoteSummaryFieldNames(person).TRAUMA_COVER,
	//     dataSet[person].traumaCover
	//   );

	//   setValue(
	//     quoteSummaryFieldNames(person).PERMANENT_DISABILITY_COVER,
	//     dataSet[person].permanentDisabilityCover,
	//     { shouldDirty: true }
	//   );
	//   setValue(
	//     quoteSummaryFieldNames(person).OCCUPATION_LIST,
	//     dataSet[person].occupationList
	//   );
	// }, [dataSet?.customerRetrieveQuoteLoaded]);

	//----------------------------------------------------------------
	return (
		<>
			<Backdrop
				sx={{ color: "#008ED6", zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={open}
			>
				<CircularProgress color="inherit" />
			</Backdrop>

			{showSecond === true ? (
				<Section
					data-identifier="first-applicant-name"
					mt={4}
					sx={{
						textAlign: { xs: "left", sm: "center" },
						ml: { xs: 1, sm: 0 },
						mb: { xs: 2 },
					}}
				>
					<Typography
						variant="h5-bold"
						ml={{ xs: 0, sm: 6 }}
						sx={{ textAlign: "left", whiteSpace: "nowrap" }}
					>
						Applicant {applicantTitle} - {currentPerson.firstName}{" "}
						{currentPerson.surname}
					</Typography>
				</Section>
			) : null}

			{/* <Section>
        <p>VALID: {isValid === true ? "true" : "false"}</p>
        <p>ERRORS: {errorFields}</p>
      </Section> */}

			<Section mt={2}>
				<CurrencyInputCard
					name={quoteSummaryFieldNames(person).LIFE_COVER}
					defaultValue={dataSet[person].lifeCover}
					title="Life cover"
					subTitle={`Please select cover amount between ${formatCurrencyNoDecimal(
						LIFE_INSURANCE_MIN[dataSet[person].minAgeGroup]
					)} and  ${formatCurrencyNoDecimal(
						LIFE_INSURANCE_MAX[dataSet[person].maxAgeGroup]
					)} `}
					placeholder="Cover amount"
					label="Cover amount"
					backgroundColor={`${theme.palette.soft.softBeige150}`}
					showPremium={
						!open && lifeCoverValid === true && isLifeCoverUpdated === true
					}
					frequency={toUpperFirstCharacterFirstWord(
						frequencyDisplay[frequency]
					)}
					premiumAmount={
						!open && lifeCoverValid === true
							? formatCurrency(quoteInfo.covers.life[frequency])
							: null
					}
					{...(!isOnline && { tooltipWidth: 700 })}
					tooltipText={
						isOnline
							? selectCoverTooltips.LIFE_COVER_TOOLTIP
							: selectCoverTooltips.LIFE_COVER_TOOLTIP_CONTACT_CENTRE
					}
					onBlur={(e) => {
						handleOnBlur(e);
					}}
				/>
			</Section>
			{quoteIsLoading === false &&
			dataSet[person].showAdditionalCover === true ? (
				<>
					<Section mt={2}>
						<CurrencyInputCard
							name={quoteSummaryFieldNames(person).CRITICAL_ILLNESS_COVER}
							defaultValue={dataSet[person].illnessCover}
							title="Critical Illness cover (optional)"
							subTitle={`Please select cover amount between ${formatCurrencyNoDecimal(
								CRITICAL_ILLNESS_MIN[dataSet[person].minAgeGroup]
							)} and ${formatCurrencyNoDecimal(
								CRITICAL_ILLNESS_MAX[dataSet[person].maxAgeGroup]
							)} `}
							placeholder="Cover amount"
							label="Cover amount"
							backgroundColor={`${theme.palette.greyscale.Grey600}`}
							showPremium={
								quoteInfo?.covers?.hasCriticalIllnessCover &&
								isCriticalIllnessCoverUpdated === true
							}
							showCheckbox={true}
							frequency={toUpperFirstCharacterFirstWord(
								frequencyDisplay[frequency]
							)}
							checked={criticalIllnessChecked}
							premiumAmount={
								quoteInfo?.covers?.hasCriticalIllnessCover
									? formatCurrency(
											quoteInfo?.covers?.criticalIllness[frequency]
										)
									: null
							}
							checkedOnChange={(e) => {
								handleCriticalIllnessCheckedChange(e);
							}}
							onBlur={(e) => {
								handleOnBlur(e);
							}}
							{...(!isOnline && { tooltipWidth: 700 })}
							tooltipText={
								isOnline
									? selectCoverTooltips.CRITICAL_ILLNESS_TOOLTIP
									: selectCoverTooltips.CRITICAL_ILLNESS_TOOLTIP_CONTACT_CENTRE
							}
						/>

						{showAllTraumaCover ? (
							<Section
								textAlign="left"
								sx={{ px: 3, pb: 3, maxWidth: { xs: "690px" } }}
								mb={0}
								mt={4}
							>
								<RHFCircleToggleGroupLabelled
									variant="circle-group"
									name={quoteSummaryFieldNames(person)?.TRAUMA_COVER}
									items={questionTypes.YES_NO}
									label={{ text: questionLabels.TRAUMA_COVER_QUESTION.label }}
									description={
										isOnline
											? questionLabels.TRAUMA_COVER_QUESTION.description.online
											: questionLabels.TRAUMA_COVER_QUESTION.description
													.contactCentre
									}
									position={{ xs: "center", sm: "left" }}
									minHeight={0}
								/>
							</Section>
						) : null}
					</Section>
				</>
			) : null}
			{quoteIsLoading === false &&
			dataSet[person].showAdditionalCover === true ? (
				<>
					<Section mt={2}>
						<CurrencyInputCard
							name={quoteSummaryFieldNames(person).PERMANENT_DISABILITY_COVER}
							defaultValue={dataSet[person].permanentDisabilityCover}
							title="Permanently unable to work cover (optional)"
							subTitle={`Please select cover amount between ${formatCurrencyNoDecimal(
								PERMANENT_DISABILITY_MIN[dataSet[person].minAgeGroup]
							)} and ${formatCurrencyNoDecimal(
								PERMANENT_DISABILITY_MAX[dataSet[person].maxAgeGroup]
							)}`}
							placeholder="Cover amount"
							label="Cover amount"
							backgroundColor={`${theme.palette.greyscale.Grey600}`}
							showPremium={
								quoteInfo?.covers?.hasUnableToWorkCover &&
								isPermanentDisabilityUpdated === true
							}
							showCheckbox={true}
							frequency={toUpperFirstCharacterFirstWord(
								frequencyDisplay[frequency]
							)}
							checked={permanentUnableToWorkChecked}
							premiumAmount={
								quoteInfo?.covers?.hasUnableToWorkCover
									? formatCurrency(quoteInfo?.covers?.unableToWork[frequency])
									: null
							}
							checkedOnChange={(e) => {
								handleUnableToWorkCheckedChange(e);
							}}
							onBlur={(e) => {
								handleOnBlur(e);
							}}
							{...(!isOnline && { tooltipWidth: 700 })}
							tooltipText={
								isOnline
									? selectCoverTooltips.PERMANENT_DISABILITY_TOOLTIP
									: selectCoverTooltips.PERMANENT_DISABILITY_TOOLTIP_CONTACT_CENTRE
							}
						/>
						{showOccupationTypeCover && (
							<Section
								textAlign="left"
								sx={{ maxWidth: { xs: "690px" }, px: 3, pb: 3 }}
								mt={4}
								mb={0}
							>
								<RHFRadioGroup
									name={quoteSummaryFieldNames(person).OCCUPATION_LIST}
									defaultValue={dataSet[person].occupationList}
									label="Occupation Type"
									items={occupationTypeList}
									radioPosition="flex-start"
								/>
							</Section>
						)}
					</Section>
				</>
			) : null}

			{premiumProjectionData ? (
				<Section mt={4}>
					<AccordionTables
						frequency={frequency}
						person={person}
						dataSet={dataSet}
						showSecond={showSecond}
						premiumData={premiumProjectionData}
						parentPage="quoteSummaryPage"
					/>
				</Section>
			) : null}
		</>
	);
}
